import React from 'react';
import Container from '@mui/material/Container';

import { useGutterSpacing } from '@/hooks/use-gutter-spacing';
import { H3 } from '@/components/type';
import { urlFor } from '@/utils/sanity-image';

import {
  ContentGridWrapper,
  Image,
  ImageWrapper,
  ItemBody,
  ItemHeader,
  ItemWrapper,
  StyledGrid,
  Title,
} from './styles';
import { type HsiycContentGridBlock } from '@tac/sanity-client/types';
import { type Dereference } from '@tac/sanity-client/type-utils';

const ContentGridBlock = ({ heading, items = [] }: Dereference<HsiycContentGridBlock>) => {
  const itemCount = items.length;
  const columnsOnDesktop = itemCount !== 2 && itemCount <= 4 ? 12 / itemCount : 4; // Set to max of 4 items in admin
  const hasMoreThanOneItem = itemCount > 1;

  return (
    <Container maxWidth="xl">
      <ContentGridWrapper>
        {heading && (
          <Title>
            <H3>{heading}</H3>
          </Title>
        )}
        <StyledGrid container spacing={useGutterSpacing()}>
          {items.map((item, index) => {
            const imageUrl = urlFor(item.image)?.url?.();
            return (
              <StyledGrid item xs={12} sm={hasMoreThanOneItem ? 6 : 12} lg={columnsOnDesktop} key={index}>
                <ItemWrapper>
                  {imageUrl && (
                    <ImageWrapper>
                      <Image src={imageUrl} alt={item.heading} />
                    </ImageWrapper>
                  )}
                  {item.heading && <ItemHeader>{item.heading}</ItemHeader>}
                  {item.body && <ItemBody portableTextValue={item.body} />}
                </ItemWrapper>
              </StyledGrid>
            );
          })}
        </StyledGrid>
      </ContentGridWrapper>
    </Container>
  );
};

export default ContentGridBlock;
